<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        title="Filters"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOW') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
                />
                <b-button
                  v-if="$ability.can(constants.action.permissionFilterListAdd, constants.resource.filterLists)"
                  variant="primary"
                  :to="{name:'add-filter-list'}"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_FILTER_LIST') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <div
          class="resource-listing"
        >
          <b-table
            ref="roles"
            class="position-relative "
            :fields="filterListFields"
            :items="filterListData"
          >
            <template #cell(id)="data">
              <b-link
                :href="`/view-filter-details/${data.item.id}`"
                target="_blank"
              >
                <div>{{ data.item.id }}</div>
              </b-link>
            </template>
            <template #cell(type)="data">
              <b-link
                :href="`/view-filter-details/${data.item.id}`"
                target="_blank"
              >
                <div>{{ data.item.type }}</div>
              </b-link>
            </template>
            <template #cell(title)="data">
              <b-link
                :href="`/view-filter-details/${data.item.id}`"
                target="_blank"
              >
                <div>{{ data.item.title }}</div>
              </b-link>
            </template>
            <template #cell(description)="data">
              <b-link
                :href="`/view-filter-details/${data.item.id}`"
                target="_blank"
              >
                <div><p class="list-description">
                  {{ getDescription(data.item.description) }}</p></div>
                <b-link
                  v-if="(data.item.description).length > 50"
                  v-b-modal.filter-description-modal
                  class="font-weight-bold d-block text-nowrap see-more-link"
                  @click="filterDescription = data.item.description"
                >({{ $t('DEBTIA_SEE_MORE') }})
                </b-link>
              </b-link>
            </template>
            <template #cell(action)="data">
              <div class="demo-inline-spacing">
                <b-link
                  :to="{ name: 'view-filter-list', params: { id: data.item.id } }"
                  class="margin-right: 15px; font-weight-bold d-block text-nowrap list-links"
                  target="_blank"
                >
                  <div
                    class="padding-right-10"
                  >
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      class="btn-icon mt-0 list-button"
                    >
                      <feather-icon
                        icon="Edit2Icon"
                      />
                    </b-button>
                  </div>
                </b-link>
              </div>
            </template>
          </b-table>
        </div>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOW') }} {{ from }} {{ $t('DEBTIA_TO') }} {{ to }} {{ $t('DEBTIA_OF') }} {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal
      id="filter-description-modal"
      title="Filter Description"
      hide-footer
      centered
    >
      <b-card-text>
        {{ filterDescription }}
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination, BLink, BModal, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import Ripple from 'vue-ripple-directive'
// import AddModal from './AddModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    // AddModal,
    BLink,
    BModal,
    BCardText,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      // taskFields: [
      //   { key: 'id', sortable: true },
      //   { key: 'title', sortable: true },
      //   'Action',
      // ],
      filterListData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      modalLoader: true,
      constants,
      buttonTitle: '',
      cases: [],
      debtors: [],
      clients: [],
      filterDescription: null,
    }
  },
  computed: {
    filterListFields() {
      return [
        { key: 'id', sortable: true, label: this.$t('DEBTIA_ID') },
        { key: 'type', sortable: true, label: this.$t('DEBTIA_TYPE') },
        { key: 'title', sortable: true, label: this.$t('DEBTIA_TITLE') },
        {
          key: 'description', sortable: true, class: 'filterDescription', label: this.$t('DEBTIA_DESCRIPTION'),
        },
        { key: 'Action', label: this.$t('DEBTIA_ACTION') },
      ]
    },
  },
  watch: {
    searchQuery: {
      handler() {
        this.getFilterList()
      },
    },
    currentPage: {
      handler() {
        this.getFilterList()
      },
    },
    perPage: {
      handler() {
        this.getFilterList()
      },
    },
  },
  created() {
    this.getFilterList()
  },
  methods: {
    getDescription(description) {
      return description.length > 50 ? `${description.slice(0, 50)}...` : description
    },
    async getFilterList() {
      try {
        this.loader = true
        const allFilters = await axios.get('/get-all-filter-lists', {
          params: {
            perPage: this.perPage,
            q: this.searchQuery,
            page: this.currentPage,
          },
        })
        if (allFilters.status) {
          this.filterListData = allFilters.data.data.data
          this.totalPages = allFilters.data.data.total
          this.from = allFilters.data.data.from
          this.to = allFilters.data.data.to
          this.currentPage = allFilters.data.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.list-button {
  margin-right: 0.04rem;
}

.list-links {
  margin: 0px;
}

.see-more-link {
  margin-top: 38px;
}

.list-description {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.padding-left-0 {
  padding-left: 0px !important;
}

.padding-right-10 {
  padding-right: 10px !important;
}
</style>
